import React from "react";

const AddUnitIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_3432_275"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3432_275)">
        <path
          d="M17 9H19V7H17V9ZM18 23C16.6167 23 15.4375 22.5125 14.4625 21.5375C13.4875 20.5625 13 19.3833 13 18C13 16.6167 13.4875 15.4375 14.4625 14.4625C15.4375 13.4875 16.6167 13 18 13C19.3833 13 20.5625 13.4875 21.5375 14.4625C22.5125 15.4375 23 16.6167 23 18C23 19.3833 22.5125 20.5625 21.5375 21.5375C20.5625 22.5125 19.3833 23 18 23ZM17.5 21H18.5V18.5H21V17.5H18.5V15H17.5V17.5H15V18.5H17.5V21ZM23 13.125C22.35 12.425 21.5917 11.8958 20.725 11.5375C19.8583 11.1792 18.95 11 18 11C17.8167 11 17.6458 11.0042 17.4875 11.0125C17.3292 11.0208 17.1667 11.0417 17 11.075V10L10 4.95V3H23V13.125ZM1 21V11L8 6L15 11V11.675C13.8 12.2417 12.8333 13.1042 12.1 14.2625C11.3667 15.4208 11 16.6667 11 18C11 18.5167 11.0542 19.0292 11.1625 19.5375C11.2708 20.0458 11.4417 20.5333 11.675 21H10V15H6V21H1Z"
          fill="#03579E"
        />
      </g>
    </svg>
  );
};

export default AddUnitIcon;
